import React from 'react';
import PropTypes from 'prop-types';
import {useStyles, Icon} from '@ace-de/ui-components';
import styles from './ServiceCategoryTitle.module.scss';

const ServiceCategoryTitle = props => {
    const {cx} = useStyles(props, styles);
    const {icon, children} = props;

    return (
        <div className={cx('ace-c-service-category-title')}>
            <Icon
                className={cx([
                    'ace-c-icon--24',
                    'ace-c-icon--color-highlight',
                    'ace-c-service-category-title__icon',
                ])}
                icon={icon}
            />
            <p
                className={cx([
                    'global!ace-u-typography--variant-body-medium',
                    'global!ace-u-typography--color-highlighted',
                    'ace-c-service-category-title__title',
                ])}
            >
                {children}
            </p>
        </div>
    );
};

ServiceCategoryTitle.propTypes = {
    icon: PropTypes.object.isRequired,
};

export default ServiceCategoryTitle;
